<template>
  <div>
    <router-link v-if="currentInternStatusGetter == 'unapplied_or_expired'" to="/enterprises/intern" id="intern_apply" class="btn--pill pill blue">
      申請實習業務功能
    </router-link>
    <button v-if="currentInternStatusGetter == 'under_review'" id="intern_apply" class="btn--pill pill darken_blue" disabled>
      申請實習業務功能 (審核中)
    </button>
    <router-link v-if="currentInternStatusGetter == 'is_enabled'" to="/enterprises/intern/intern-record" id="intern_apply" class="btn--pill pill blue">
      實習業務
    </router-link>
    <enterprise-profile-form-new
      :current-enterprise="currentEnterpriseGetter"
      lock-gui-number
      @submit="submitProfile"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EnterpriseProfileFormNew from '../EnterpriseProfileFormNew'
export default {
  name: 'EnterpriseAccountSettings',
  components: {
    EnterpriseProfileFormNew
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentEnterpriseGetter',
      'currentInternBasicInfoGetter',
      'currentInternStatusGetter',
    ]),
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'updateEnterpriseProfile',
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    async submitProfile (profile) {
      this.togglePageLoader(true)
      await this.updateEnterpriseProfile(profile)
      this.togglePageLoader(false)
    }
  }
}
</script>
<style lang="scss" scoped>
#intern_apply {
  line-height: 35px;
  
  @media (min-width: 768px) {
    position: absolute;
    top: -50px;
    right: 0;
  }
  
  @media (max-width: 768px) {
    margin: 0 auto 160px;
    display: block;
    width: max-content;
  }
}
</style>
